import * as React from "react";
import { Typography, Button } from "antd";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
import { IOrganisation } from "../../../organisations/model/Organisation";
import SelectInput from "../../../core/ui/components/SelectInput";
import { IUser } from "../../../user/model/User";
export interface State {}
export interface Props {
  translate: any;
  organisationIndexCategories: IOrganisationIndexCategory[];
  organisations: IOrganisation[];
  setOrganisationId: (mainOrganisationId: number) => void;
  organisationId: number;
  setCategoryId: (categoryId: number) => void;
  getData: () => void;
  selectedCategoryId: number;
  user?: IUser;
}

export default class IndexesByCategoryDataParamBox extends React.Component<
  Props,
  State
> {
  constructor(props: any) {
    super(props);
    this.state = { ...props, selectedApplicants: [] };
  }

  render() {
    const {
      translate,
      organisations,
      setOrganisationId,
      organisationId,
      getData,
      selectedCategoryId,
      organisationIndexCategories,
      setCategoryId,
      user
    } = this.props;
    return (
      <div
        style={{
          width: "22%",
          display: "flex",
          flexDirection: "column",
          minWidth: "22%",
          paddingRight: "10px"
        }}
      >
        <div
          style={{ display: "flex", flexDirection: "column", height: "auto" }}
        >
          <Typography.Title style={{ fontSize: 14 }}>
            {translate("reports.organisation")}
          </Typography.Title>
          <SelectInput
            placeholder={translate(
              "editors.attachment_types.select_organisation"
            )}
            disabled={user?.isOperator()}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            selectOptions={organisations}
            value={organisationId}
            onChange={(value) => setOrganisationId(value)}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 10,
            height: "auto"
          }}
        >
          <Typography.Title style={{ fontSize: 14 }}>
            {translate("reports.category")}
          </Typography.Title>
          <SelectInput
            placeholder={translate("reports.select_categories")}
            disabled={organisationId === undefined ?? false}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            selectOptions={organisationIndexCategories}
            value={selectedCategoryId}
            onChange={(value) => setCategoryId(value)}
          />
        </div>
        <Button
          disabled={!organisationId || !selectedCategoryId}
          style={{ marginTop: "20px" }}
          type="primary"
          onClick={() => getData()}
        >
          {translate("reports.generate_report")}
        </Button>
      </div>
    );
  }
}
